const ShowHideFilterButton = ({
  show,
  setShow,
}: {
  show: boolean;
  setShow: (show: boolean) => void;
}) => {
  return show ? (
    <button className="text-left" onClick={() => setShow(false)}>
      Hide filters
    </button>
  ) : (
    <button className="text-left" onClick={() => setShow(true)}>
      Show filters
    </button>
  );
};

export const ShowHideFilters = ({
  showMobile,
  setShowMobile,
  showDesktop,
  setShowDesktop,
}: {
  showMobile: boolean;
  setShowMobile: (show: boolean) => void;
  showDesktop: boolean;
  setShowDesktop: (show: boolean) => void;
}) => {
  return (
    <>
      <div className="hidden lg:block">
        <ShowHideFilterButton show={showDesktop} setShow={setShowDesktop} />
      </div>
      <div className="lg:hidden">
        <ShowHideFilterButton show={showMobile} setShow={setShowMobile} />
      </div>
    </>
  );
};
